// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsComposeAltSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.005 2.146a.5.5 0 0 1 .707 0l1.074 1.075a.5.5 0 0 1 0 .707l-1.06 1.06-1.782-1.78zm-1.207 4.77c.13.336.202.702.202 1.084v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h11c.345 0 .677.058.985.166l1.58-1.58 1.781 1.782zm0 0a3.009 3.009 0 0 0-1.813-1.75l-5.644 5.644c-.09.09-.163.194-.215.308l-1.113 2.412-.002.005a.312.312 0 0 0 .384.378l2.417-1.106a1.07 1.07 0 0 0 .311-.216z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsComposeAltSolid;
